import { createBrowserRouter } from "react-router";
import { createRoutes } from "./routes";

export { createRoutes } from "./routes";

export const router = createBrowserRouter(createRoutes());
